import { dollarFormatter } from 'shared/utils/formatters/dollarFormatter';
import { IEntry, ISheet, QuantityType } from 'shared/models/sheet/Sheet';
import { convertToCents } from 'shared/utils/converters/convertToCents';
import { getFormattedMiles, getFormattedOdometer } from 'shared/components/formSpecialFields/expenseData/utils';
import Decimal from 'decimal.js';

export function dollarCounter(totalCents: number): string {
    const dollars = Math.floor(totalCents / 100);
    const cents = (totalCents - dollars * 100);
    return dollarFormatter(dollars, cents);
}

export function totalDollars(entries: Array<IEntry>, mileageRate: Decimal): number {
    return entries.reduce(
        (acc: number, entry) => {
            if (entry.data.entry_type === QuantityType.MONEY) {
                return acc + convertToCents(entry.data.dollars);
            }
            if (entry.data.entry_type === QuantityType.ODOMETER) {
                return acc + convertToCents(getFormattedOdometer(entry.data, mileageRate));
            }
            if (entry.data.entry_type === QuantityType.MILES) {
                return acc + convertToCents(getFormattedMiles(entry.data.miles, mileageRate));
            }
            return acc;
        },
        0,
    ) * 0.01;
}

export function sheetsTotalDollars(sheets: Array<ISheet>): number {
    return sheets.reduce((acc: number, sheet) => acc + convertToCents(sheet.total_dollars), 0) * 0.01;
}
